import styled from 'styled-components';

type BackgroundProps = {
  $background?: string;
};

type ImageProps = {
  $align?: 'right' | 'left';
};

export const Background = styled.div<BackgroundProps>`
  background: ${(props) => props['$background'] || props.theme.background};
  height: 100vh;
  overflow: hidden;
  width: 100vw;
`;

export const Image = styled.img<ImageProps>`
  height: 100vh;
  position: absolute;
  ${(props) => ((props['$align'] || props.theme.align) === 'left' ? 'left: 0;' : 'right: 0;')};
  bottom: 0;
  margin-top: auto;
`;
